import { formatDate } from '@/utils/tableColumns';
import formatarEmMoeda from '@/utils/formatarMoedaUtils';

export default {
  SET_PROCESSOS_COMISSOES(state, payload) {
    if (Array.isArray(payload)) {
      state.processosComissoes = payload.map((comissao) => ({
        ...comissao,
        dataComissao: comissao.dataComissao ? formatDate(comissao.dataComissao) : 'N/I',
        valorComissao: comissao.valorComissao ? formatarEmMoeda(comissao.valorComissao, 'BRL') : 'N/I',
        valorNota: comissao.valorNota ? formatarEmMoeda(comissao.valorNota, 'BRL') : 'N/I',
        valorIcms: comissao.valorIcms ? formatarEmMoeda(comissao.valorIcms, 'BRL') : 'N/I',
      }));
    } else {
      state.processosComissoes = [];
    }
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
};
